export function decimalToDMS(decimal, isLatitude) {
  const degrees = Math.abs(Math.floor(decimal));
  const minutesWithDecimal = (Math.abs(decimal) - degrees) * 60;
  const minutes = Math.floor(minutesWithDecimal);
  const seconds = (minutesWithDecimal - minutes) * 60;
  const direction = isLatitude ? (decimal >= 0 ? 'N' : 'S') : (decimal >= 0 ? 'E' : 'W');
  return `${degrees}° ${minutes}' ${seconds.toFixed(2)}" ${direction}`;
}

export function getLatLngGeoson(object, type) {
  const jsonObj = object.geoJson ? JSON.parse(object.geoJson) : object
  let value
  if (object.geoJson) {
    if (type == 'latitude') {
      value = jsonObj?.features[0]?.geometry?.coordinates.length != 2 ? jsonObj?.features[0]?.geometry?.coordinates[0][0] : jsonObj?.features[0]?.geometry?.coordinates[0]
    } else if (type == 'longitude') {
      value = jsonObj?.features[0]?.geometry?.coordinates.length != 2 ? jsonObj?.features[0]?.geometry?.coordinates[0][1] : jsonObj?.features[0]?.geometry?.coordinates[1]
    }
  } else {
    if (type == 'latitude') {
      value = object.latitude
    }
    if (type == 'longitude') {
      value = object.longitude
    }
  }

  return value

}

// export let dateConvertion = (date) => {
//   if (date) {
//     const inputDate = date;
//     const dateObject = new Date(inputDate);
//     // Format the date
//     const options = { month: 'numeric', day: 'numeric', year: '2-digit', hour: 'numeric', minute: 'numeric', hour12: true };
//     const formattedDate = dateObject.toLocaleDateString('en-US', options);
//     return formattedDate
//   } else {
//     return
//   }
// }

export const dateConvertion = date => {
  if (date) {
    let displayDate = Date.now()
    displayDate = new Date(displayDate)
    if (date) {
      date.length > 24 ? date = date.slice(0, 24) : null
      displayDate = new Date(date)
    }
    var localOffset = displayDate.getTimezoneOffset() * 60000
    var localTime = displayDate.getTime()
    displayDate = localTime - localOffset
    displayDate = new Date(displayDate)
    const options = { month: 'numeric', day: 'numeric', year: '2-digit', hour: 'numeric', minute: 'numeric', hour12: true };
    let displayDateString = displayDate.toLocaleDateString('en-US', options)
    return displayDateString
  } else {
    return false
  }
}